// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webmapp-modalcoins {
  padding: 16px;
}
.webmapp-modalcoins .webmapp-modalcoins-header {
  width: 50px;
  border-radius: 25px;
  margin-left: -10px;
}
.webmapp-modalcoins .webmapp-modalcoins-header .webmapp-modalcoins-closebtn {
  width: 24px;
  height: 24px;
  color: var(--wm-color-dark);
  padding: 10px;
}
.webmapp-modalcoins .webmapp-modalcoins-title {
  font-weight: var(--wm-font-weight-bold);
  font-size: var(--wm-font-xxxlg);
  color: var(--wm-color-dark);
  padding-top: 5px;
  display: block;
}
.webmapp-modalcoins .webmapp-modalcoins-info {
  position: relative;
  margin: 25px 0;
}
.webmapp-modalcoins .webmapp-modalcoins-info .wwebmapp-modalcoins-info-check {
  position: absolute;
  left: 0;
  top: 0;
  color: var(--wm-color-green);
}
.webmapp-modalcoins .webmapp-modalcoins-info .webmapp-modalcoins-info-main {
  padding-left: 30px;
  display: inline-block;
  font-weight: var(--wm-font-weight-bold);
  font-size: var(--wm-font-md);
  color: var(--wm-color-dark);
}
.webmapp-modalcoins .webmapp-modalcoins-info .webmapp-modalcoins-info-sub {
  padding-left: 30px;
  display: inline-block;
  font-weight: var(--wm-font-weight-light);
  font-size: var(--wm-font-sm);
}
.webmapp-modalcoins .wwebmapp-modalcoins-buttoncontainer {
  text-align: center;
  padding: 20px;
}
.webmapp-modalcoins .wwebmapp-modalcoins-buttoncontainer .wwebmapp-modalcoins-buttonone {
  --border-radius: 20px;
  margin: 20px 0;
}
.webmapp-modalcoins .wwebmapp-modalcoins-buttoncontainer .wwebmapp-modalcoins-buttonone .webmapp-modalcoins-button-image {
  margin-right: 15px;
}
.webmapp-modalcoins .wwebmapp-modalcoins-buttoncontainer .wwebmapp-modalcoins-buttonall {
  --border-radius: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-coins/modal-coins.component.scss"],"names":[],"mappings":"AAEA;EAII,aAAA;AAJJ;AAMI;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;AAJR;AAMQ;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EAEA,aAAA;AALZ;AASI;EACI,uCAAA;EACA,+BAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;AAPR;AAUI;EACI,kBAAA;EACA,cAAA;AARR;AAUQ;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,4BAAA;AARZ;AAWQ;EACI,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,4BAAA;EACA,2BAAA;AATZ;AAYQ;EACI,kBAAA;EACA,qBAAA;EACA,wCAAA;EACA,4BAAA;AAVZ;AAcI;EACI,kBAAA;EACA,aAAA;AAZR;AAcQ;EACI,qBAAA;EACA,cAAA;AAZZ;AAaY;EACI,kBAAA;AAXhB;AAcQ;EACI,qBAAA;AAZZ","sourcesContent":["@import \"src/theme/mixins.scss\";\n\n.webmapp-modalcoins {\n    //   width: 100%;\n    //   height: 100%;\n    //   --background: var(--wm-color-secondary);\n    padding: 16px;\n\n    .webmapp-modalcoins-header {\n        width: 50px;\n        border-radius: 25px;\n        margin-left: -10px;\n\n        .webmapp-modalcoins-closebtn {\n            width: 24px;\n            height: 24px;\n            color: var(--wm-color-dark);\n\n            padding: 10px;\n        }\n    }\n\n    .webmapp-modalcoins-title {\n        font-weight: var(--wm-font-weight-bold);\n        font-size: var(--wm-font-xxxlg);\n        color: var(--wm-color-dark);\n        padding-top: 5px;\n        display: block;\n    }\n\n    .webmapp-modalcoins-info {\n        position: relative;\n        margin: 25px 0;\n\n        .wwebmapp-modalcoins-info-check {\n            position: absolute;\n            left: 0;\n            top: 0;\n            color: var(--wm-color-green);\n        }\n\n        .webmapp-modalcoins-info-main {\n            padding-left: 30px;\n            display: inline-block;\n            font-weight: var(--wm-font-weight-bold);\n            font-size: var(--wm-font-md);\n            color: var(--wm-color-dark);\n        }\n\n        .webmapp-modalcoins-info-sub {\n            padding-left: 30px;\n            display: inline-block;\n            font-weight: var(--wm-font-weight-light);\n            font-size: var(--wm-font-sm);\n        }\n    }\n\n    .wwebmapp-modalcoins-buttoncontainer {\n        text-align: center;\n        padding: 20px;\n\n        .wwebmapp-modalcoins-buttonone {\n            --border-radius: 20px;\n            margin: 20px 0;\n            .webmapp-modalcoins-button-image {\n                margin-right: 15px;\n            }\n        }\n        .wwebmapp-modalcoins-buttonall {\n            --border-radius: 20px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
